import axios from 'axios';

class Api {
    async getRedirectMethod(token, data) {
        try {
            console.log(data)

            const response = await axios.post(
                '/api/redirect_method', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response;
        } catch (error) {
            return error.response
        }
    }
    async callBackLog(token, redirectConfig, redirectLink, protect, browser) {
        try {
            const data = {
                redirectConfig: redirectConfig,
                redirectLink: redirectLink,
                protect: protect,
                browser: browser
            }
            console.log(data)
            const response = await axios.post(
                '/api/log_call_back', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response;
        } catch (error) {
            return error.response
        }
    }

}
export default new Api()